export enum PriceContext {
  PRODUCT_INTRO,
  PRODUCT_COMBO_OPTION,
  PRODUCT_CARD,
}

export enum CompareAtPriceDisplay {
  STRIKETHROUGH = "strikethrough",
  VALUE = "value",
}
